import { usePetitionDetailsPageState } from '#src/app/pages/petitionDetails/pageContext';

export function useSignFormStep(): {
	signFormStep: 1 | 2;
	setSignFormStep: (step: 1 | 2) => void;
} {
	const [state, mutations] = usePetitionDetailsPageState();
	return {
		signFormStep: state.signFormStep,
		setSignFormStep: mutations.updateSignFormStep,
	};
}
